// CoverageMap.jsx
import React, { useState } from "react";
import {
  MapContainer,
  TileLayer,
  Circle,
  Tooltip,
  useMap,
} from "react-leaflet";
import "leaflet/dist/leaflet.css";
import {
  Box,
  Typography,
  Paper,
  List,
  ListItem,
  ListItemButton,
} from "@mui/material";

// Base city coordinates for Memphis cluster
const CITY_COORDS = {
  Memphis: [35.1495, -90.0490],
  Bartlett: [35.2045, -89.87398],
  Arlington: [35.2968, -89.6612],
  Lakeland: [35.2306, -89.7401],
};

// ─────────────────────────────────────────────
// Coverage Zones
// ─────────────────────────────────────────────
const COVERAGE_ZONES = [
  // ─────────── Memphis ND accounts (4 live logins) ───────────

  {
    name: "Memphis 1 — North Anchor (3582 Kensett Dr, 38127)",
    center: [35.2562, -90.0657],   // 38127 centroid
    radiusMiles: 9,
  },
  {
    name: "Memphis 2 — Bartlett / NE (8016 US-70, 38133)",
    center: [35.2099, -89.7919],   // 38133 centroid
    radiusMiles: 8,
  },
  {
    name: "Memphis 3 — Southeast / Hickory Hill (7964 Tankerston Dr, 38125)",
    center: [35.0292, -89.7770],   // 38125 centroid
    radiusMiles: 9,
  },
  {
    name: "Memphis 4 — Whitehaven / Airport (5604 Loch Lomond Rd, 38116)",
    center: [35.0342, -90.0117],   // 38116 centroid
    radiusMiles: 8,
  },

  // ── Northern Virginia ND accounts (5+ live logins) ──

  // ── Northern Virginia ND accounts (5+ live logins) ──

{
  name: "Account A — Fairfax (12652 Heron Ridge Dr, Fairfax, VA 22030)",
  center: [38.845975, -77.338414],
  radiusMiles: 7,
},
{
  name: "Account B — Arlington (1704 N Calvert St, Arlington, VA 22201)",
  center: [38.8848, -77.0915],
  radiusMiles: 4,
},
{
  name: "Account C — Sterling / Dulles (1073 Temple Ct)",
  center: [39.006699, -77.429131],
  radiusMiles: 7,
},
{
  name: "Account D — Woodbridge (3826 Ogilvie Ct, Woodbridge, VA 22192)",
  center: [38.6581722, -77.2497049],
  radiusMiles: 8,
},
{
  name: "Account E — Groveton / Alexandria (4512 Lantern Pl)",
  center: [38.765657, -77.112278],
  radiusMiles: 8,
},
{
  name: "Account F — Gainesville (13568 Heritage Farms Dr, Gainesville, VA 20155)",
  center: [38.79384, -77.61372],
  radiusMiles: 9,
},
    {
    name: "Houston 1 — Galleria / 77057 (2924 El Fenice Ln)",
    center: [29.74424, -95.49397],
    radiusMiles: 9,
  },
  {
    name: "Houston 2 — South Central / 77021 (3906 Southlawn St)",
    center: [29.70462, -95.36094],
    radiusMiles: 9,
  },
  {
    name: "Houston 3 — Northeast / 77026 (2218 Noble St)",
    center: [29.78727, -95.33859],
    radiusMiles: 9,
  },
  {
    name: "Houston 4 — Southwest / 77083 (9411 Spindlewood Dr)",
    center: [29.68018, -95.65568],
    radiusMiles: 9,
  },
  {
    name: "Houston 5 — West / 77084 (15603 Sandy Hill Dr)",
    center: [29.83812, -95.66012],
    radiusMiles: 9,
  },
  {
    name: "Houston 6 — Southeast / 77034 (12635 Baker Bend St)",
    center: [29.62690, -95.18880],
    radiusMiles: 9,
  },

    // ─────────── Dallas ND accounts (12) ───────────
{ name: "Dallas 1 — 75201", center: [32.7876, -96.7994], radiusMiles: 7 },

{ name: "Dallas 2 — 75007 (Carrollton)", center: [32.9756, -96.8890], radiusMiles: 7 },
{ name: "Dallas 3 — 75040 (Garland)", center: [32.9126, -96.6389], radiusMiles: 7 },

{ name: "Dallas 4 — 75038 (Irving)", center: [32.8760, -96.9900], radiusMiles: 7 },

{ name: "Dallas 5 — 76051 (Grapevine)", center: [32.9343, -97.0781], radiusMiles: 7 },

{ name: "Dallas 6 — 75052 (Grand Prairie)", center: [32.6750, -97.0300], radiusMiles: 7 },
{ name: "Dallas 7 — 76010 (Arlington)", center: [32.7357, -97.1081], radiusMiles: 7 },

{ name: "Dallas 8 — 76107 (Fort Worth)", center: [32.7390, -97.3900], radiusMiles: 7 },
{ name: "Dallas 9 — 76108 (White Settlement)", center: [32.7600, -97.4600], radiusMiles: 7 },

{ name: "Dallas 10 — 75071 (McKinney)", center: [33.1970, -96.6398], radiusMiles: 7 },

{ name: "Dallas 11 — 76201 (Denton)", center: [33.2148, -97.1331], radiusMiles: 7 },

{ name: "Dallas 12 — 75146 (Lancaster)", center: [32.5921, -96.7561], radiusMiles: 7 },

  // ─────────── South Florida ND accounts (6) ───────────
  // miniCluster: rendered as 30-40 small circles scattered inside the bound
  // instead of one big circle (see generateMiniCircles below).
{ name: "South Florida 1 — 33458 (Jupiter)", center: [26.9342, -80.1160], radiusMiles: 7, miniCluster: true },
{ name: "South Florida 2 — 33401 (West Palm Beach)", center: [26.7145, -80.0658], radiusMiles: 7, miniCluster: true },
{ name: "South Florida 3 — 33414 (Wellington)", center: [26.6476, -80.2519], radiusMiles: 7, miniCluster: true },
{ name: "South Florida 4 — 33445 (Delray Beach)", center: [26.4553, -80.1044], radiusMiles: 7, miniCluster: true },
{ name: "South Florida 5 — 33433 (Boca Raton)", center: [26.3487, -80.1560], radiusMiles: 7, miniCluster: true },
{ name: "South Florida 6 — 33021 (Hollywood)", center: [26.0231, -80.1866], radiusMiles: 7, miniCluster: true },
];
const DALLAS_ZIPS = [
  "75201",
  "75204",
  "75214",
  "75228",
  "75231",
  "75240",
  "75248",
  "75254",
  "75287",
  "75230",
  "75220",
  "75212"
];
const milesToMeters = (miles) => miles * 1609.34;

// ── Mini-cluster generation (deterministic — seeded by zone name so the
//    dots stay put across renders/reloads instead of jumping around) ──
function hashSeed(str) {
  let h = 2166136261;
  for (let i = 0; i < str.length; i++) {
    h ^= str.charCodeAt(i);
    h = Math.imul(h, 16777619);
  }
  return h >>> 0;
}

function mulberry32(seed) {
  let a = seed >>> 0;
  return function () {
    a = (a + 0x6d2b79f5) | 0;
    let t = Math.imul(a ^ (a >>> 15), 1 | a);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

const MILES_PER_DEG_LAT = 69.0;

// 30-40 small circles scattered uniformly inside the zone's bound, each fully contained
function generateMiniCircles(zone) {
  const rand = mulberry32(hashSeed(zone.name));
  const count = 30 + Math.floor(rand() * 11); // 30-40
  const minis = [];
  for (let i = 0; i < count; i++) {
    const miniRadius = 0.9 + rand() * 0.5; // 0.9-1.4 mi
    const maxOffset = Math.max(zone.radiusMiles - miniRadius, 0);
    const dist = maxOffset * Math.sqrt(rand()); // sqrt -> uniform over the disk
    const theta = rand() * Math.PI * 2;
    const dLat = (dist * Math.cos(theta)) / MILES_PER_DEG_LAT;
    const dLng =
      (dist * Math.sin(theta)) /
      (MILES_PER_DEG_LAT * Math.cos((zone.center[0] * Math.PI) / 180));
    minis.push({
      center: [zone.center[0] + dLat, zone.center[1] + dLng],
      radiusMiles: miniRadius,
    });
  }
  return minis;
}

const MINI_CIRCLES_BY_ZONE = Object.fromEntries(
  COVERAGE_ZONES.filter((z) => z.miniCluster).map((z) => [
    z.name,
    generateMiniCircles(z),
  ])
);

// Helper to zoom map when we click a city in the list
function ZoomToZone({ center }) {
  const map = useMap();

  React.useEffect(() => {
    if (center) {
      map.setView(center, 11, { animate: true });
    }
  }, [center, map]);

  return null;
}

export default function CoverageMap() {
  const [highlightIndex, setHighlightIndex] = useState(null);
  const [zoomTarget, setZoomTarget] = useState(null);

  const handleSelectZone = (idx) => {
    const zone = COVERAGE_ZONES[idx];
    setHighlightIndex(idx);
    setZoomTarget(zone.center);
  };

  return (
    <Box sx={{ p: 2 }}>
      <Typography
        variant="h5"
        sx={{
          mb: 2,
          fontWeight: 700,
          color: "#a0f9b4",
          textShadow: "0 0 12px rgba(34,255,153,0.6)",
        }}
      >
        Coverage Map
      </Typography>

      <Paper
        sx={{
          height: "80vh",
          borderRadius: 3,
          overflow: "hidden",
          background:
            "radial-gradient(circle at 20% 20%, rgba(0,255,120,0.12), #020617 70%)",
          border: "1px solid rgba(56,255,140,0.25)",
          boxShadow:
            "0 0 25px rgba(0,255,140,0.35), inset 0 0 40px rgba(0,255,140,0.12)",
          display: "flex",
          flexDirection: "row",
        }}
      >
        {/* LEFT — MAP */}
        <Box sx={{ flex: 3 }}>
         <MapContainer
center={[32.85, -96.80]}  // Centered perfectly over the Northern VA / DC footprint
  zoom={10}
  style={{ height: "100%", width: "100%" }}
>
       <TileLayer
  attribution='&copy; <a href="https://carto.com/">CARTO</a>'
  url="https://cartodb-basemaps-a.global.ssl.fastly.net/light_all/{z}/{x}/{y}.png"
/>

            {zoomTarget && <ZoomToZone center={zoomTarget} />}

            {COVERAGE_ZONES.map((z, i) =>
              z.miniCluster ? (
                // Cluster zones: 15-20 mini circles inside the bound instead of one big ring
                <React.Fragment key={z.name}>
                  {MINI_CIRCLES_BY_ZONE[z.name].map((m, j) => (
                    <Circle
                      key={`${z.name}-mini-${j}`}
                      center={m.center}
                      radius={milesToMeters(m.radiusMiles)}
                      pathOptions={{
                        color: i === highlightIndex ? "#22ff88" : "#4ade80",
                        weight: i === highlightIndex ? 3 : 1.5,
                        fillColor: "#4ade80",
                        fillOpacity: i === highlightIndex ? 0.35 : 0.22,
                      }}
                      eventHandlers={{
                        click: () => handleSelectZone(i), // mini → list + zoom
                      }}
                    >
                      <Tooltip
                        direction="top"
                        offset={[0, -4]}
                        opacity={1}
                        className="custom-tooltip"
                      >
                        <div
                          style={{
                            color: "#111",
                            fontWeight: "600",
                            fontSize: "14px",
                          }}
                        >
                          {z.name}
                        </div>
                        <div style={{ color: "#222", fontSize: "12px" }}>
                          Coverage zone: {z.radiusMiles} mi ·{" "}
                          {MINI_CIRCLES_BY_ZONE[z.name].length} pockets
                        </div>
                      </Tooltip>
                    </Circle>
                  ))}
                </React.Fragment>
              ) : (
                <Circle
                  key={z.name}
                  center={z.center}
                  radius={milesToMeters(z.radiusMiles)}
                  pathOptions={{
                    color: i === highlightIndex ? "#22ff88" : "#4ade80",
                    weight: i === highlightIndex ? 4 : 2,
                    fillColor: "#4ade80",
                    fillOpacity: i === highlightIndex ? 0.3 : 0.18,
                  }}
                  eventHandlers={{
                    click: () => handleSelectZone(i), // ring → list + zoom
                  }}
                >
                  <Tooltip
                    direction="top"
                    offset={[0, -4]}
                    opacity={1}
                    className="custom-tooltip"
                  >
                    <div
                      style={{
                        color: "#111",
                        fontWeight: "600",
                        fontSize: "14px",
                      }}
                    >
                      {z.name}
                    </div>
                    <div style={{ color: "#222", fontSize: "12px" }}>
                      Radius: {z.radiusMiles} miles
                    </div>
                  </Tooltip>
                </Circle>
              )
            )}
          </MapContainer>
        </Box>

        {/* RIGHT — CITY LIST */}
        <Box
          sx={{
            flex: 1,
            bgcolor: "rgba(15,23,42,0.9)",
            borderLeft: "1px solid rgba(56,255,140,0.2)",
            overflowY: "auto",
          }}
        >
          <Typography
            sx={{
              p: 2,
              fontSize: 16,
              fontWeight: 600,
              color: "#bbf7d0",
              borderBottom: "1px solid rgba(56,255,140,0.25)",
              textShadow: "0 0 6px rgba(34,255,153,0.5)",
            }}
          >
            Cities & Coverage Zones
          </Typography>

          <List dense disablePadding>
            {COVERAGE_ZONES.map((z, i) => (
              <ListItem
                key={z.name}
                disablePadding
                sx={{
                  borderBottom: "1px solid rgba(56,255,140,0.06)",
                }}
              >
                <ListItemButton
                  onMouseEnter={() => setHighlightIndex(i)}
                  onMouseLeave={() =>
                    setHighlightIndex((prev) => (prev === i ? null : prev))
                  }
                  onClick={() => handleSelectZone(i)} // list → ring + zoom
                  sx={{
                    py: 1.5,
                    px: 2,
                    color: highlightIndex === i ? "#22ff88" : "#e5e7eb",
                    transition: "0.2s",
                    "&:hover": {
                      background: "rgba(56,255,140,0.08)",
                    },
                  }}
                >
                  {z.name}
                </ListItemButton>
              </ListItem>
            ))}
          </List>
        </Box>
      </Paper>

      {/* Tooltip glow styling */}
      <style>
        {`
          .custom-tooltip {
            background: #bbf7d0 !important;
            border-radius: 6px;
            border: 1px solid #4ade80;
            box-shadow: 0 0 10px rgba(74,222,128,0.7);
          }
        `}
      </style>
    </Box>
  );
}